export function statusTone(company) {
  const rank = String(company.rank ?? "").toLowerCase()
  if (company.passing === true || /grade\s*:?\s*a/.test(rank)) return "green"
  if (
    company.passing === false ||
    rank.includes("critical") ||
    rank.includes("failed") ||
    /grade\s*:?\s*f/.test(rank)
  ) {
    return "red"
  }
  return "yellow"
}

const usaRegions = new Set(["Texas", "Florida"])

export function filterLeaderboard(rows, filterId) {
  if (filterId === "usa") return rows.filter((row) => usaRegions.has(row.region))
  if (filterId === "australia") return rows.filter((row) => row.region === "Australia")
  if (filterId === "passing") return rows.filter((row) => row.passing)
  if (filterId === "failing") return rows.filter((row) => !row.passing)
  return rows
}
